<template>
    <article class="loader">
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
          <circle cx="50" cy="50" r="32" stroke-width="5" stroke="#1c1b28" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round"/>
        </svg>
    </article>
</template>

<script>
    export default {
        name: 'Loader',
        data() {
            return {}
        }
    }
</script>
